import { CheckOutlined } from '@ant-design/icons';
import { primaryColor } from './config';

function MilestoneScale({ total, completed, inverse }) {
  const completedClass = inverse
    ? { bg: 'bg-white', text: `text-[${primaryColor}]` }
    : { bg: `bg-[${primaryColor}]`, text: 'text-white' };
  const incompleteClass = inverse
    ? { bg: 'bg-[#00d090]', text: 'text-white' }
    : { bg: 'bg-[gray]', text: 'text-white' };

  const borderFull = '99999px';

  return (
    <div className="flex my-3 w-full relative h-5 items-center justify-between">
      <div
        style={{
          borderTopLeftRadius: borderFull,
          borderBottomLeftRadius: borderFull,
          ...(completed >= total && {
            borderTopRightRadius: borderFull,
            borderBottomRightRadius: borderFull,
          }),
          width: `${(completed / total) * 100}%`,
          left: 0,
        }}
        className={`h-1 ${completedClass.bg}`}
      />
      <div
        style={{
          borderTopRightRadius: borderFull,
          borderBottomRightRadius: borderFull,
          ...(total - completed >= total && {
            borderTopLeftRadius: borderFull,
            borderBottomLeftRadius: borderFull,
          }),
          width: `${((total - completed) / total) * 100}%`,
          right: 0,
        }}
        className={`h-1 ${incompleteClass.bg}`}
      />
      <div className="absolute w-full flex justify-around">
        {[...Array(total)].map((_, index) => {
          const classes = index < completed ? completedClass : incompleteClass;
          return (
            <div
              key={index}
              className={`w-5 h-5 rounded-full ${classes.bg} ${classes.text} flex items-center justify-center`}
            >
              <CheckOutlined />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { MilestoneScale };
